/* JIS / cj-pdp-specs.js (2026-09-26, draft-theme pilot)
   Swaps the spec-table rows when the shopper changes size or finish.

   Listens to the theme's own `variant:change:<sectionId>:<productId>` event - the
   one block.product-variant-picker.js bridges from kit's shopify:product:select and
   that price, SKU, inventory and the gallery already listen to. It fires twice per
   change (loading, then settled); both carry detail.variant, and rendering twice is
   idempotent. A null variant (unavailable combination) leaves the last rows showing.

   Rows are built with textContent, never innerHTML: the data is full of inch marks. */
(function () {
  if (window.customElements.get('cj-pdp-specs')) return

  class CjPdpSpecs extends HTMLElement {
    connectedCallback() {
      try {
        this.data = JSON.parse(this.querySelector('[data-cj-specs-json]').textContent)
      } catch (e) {
        this.data = {}
      }
      this.body = this.querySelector('[data-cj-specs-body]')
      this.evt = 'variant:change:' + this.dataset.sectionId + ':' + this.dataset.productId
      this.onChange = (e) => {
        const v = e && e.detail && e.detail.variant
        if (v && v.id != null) this.render(v.id)
      }
      document.addEventListener(this.evt, this.onChange)
    }

    disconnectedCallback() {
      document.removeEventListener(this.evt, this.onChange)
    }

    render(id) {
      if (String(id) === this.current) return
      const d = this.data[String(id)]
      if (!d || !d.rows || !d.rows.length) {
        this.hidden = true
        this.current = String(id)
        return
      }
      const frag = document.createDocumentFragment()
      const row = (label, value, url) => {
        const tr = document.createElement('tr')
        const th = document.createElement('th')
        th.scope = 'row'
        th.textContent = label
        const td = document.createElement('td')
        if (url && /^https:\/\//.test(url)) {
          const a = document.createElement('a')
          a.href = url
          a.target = '_blank'
          a.rel = 'noopener'
          a.textContent = value + ' '
          const s = document.createElement('span')
          s.className = 'cj-specs__pdf'
          s.textContent = '(PDF)'
          a.appendChild(s)
          td.appendChild(a)
        } else {
          td.textContent = value
        }
        tr.appendChild(th)
        tr.appendChild(td)
        frag.appendChild(tr)
      }
      if (d.sku) row('Item number', d.sku)
      d.rows.forEach((r) => row(r.l, r.v, r.u))
      this.body.replaceChildren(frag)
      this.hidden = false
      this.current = String(id)
    }
  }

  window.customElements.define('cj-pdp-specs', CjPdpSpecs)
})()
